<template>
  <section class="content">
    <div class="center-block row">
      <div
        v-if="getRoleType === 99"
        class="align-center col-xs-12 flex m-b-10 p-x-0"
      >
        <router-link :to="goBackInfo">
          <div class="btn btn-default flex m-r-5">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="darken-1 flex grey">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name
              ? brand.name
              : store.brand_name
                ? store.brand_name
                : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">
              菜單資訊
            </h3>
          </div>
          <div class="box-body form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon">ID</span>
                <div class="form-control form-info">
                  {{ info.menu_id }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">名稱</span>
                <div class="form-control form-info">
                  {{ info.name }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">描述</span>
                <div class="form-control form-info">
                  {{ info.description }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">備註</span>
                <div class="form-control form-info">
                  {{ info.remark }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  版本號
                </span>
                <div class="form-control form-info">
                  {{ info.ver_stamp }}
                </div>
              </div>
              <br>
            </div>
          </div>

          <div class="box-body form-right">
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  鎖定狀態
                </span>
                <div class="form-control form-info">
                  <span
                    v-if="info.is_locked"
                    class="label label-danger"
                  >
                    鎖定
                  </span>
                  <span
                    v-if="!info.is_locked"
                    class="label label-success"
                  >
                    可更新
                  </span>
                  <button
                    v-if="info.is_locked && info.status === 2"
                    class="btn btn-default"
                    @click="menuUnlock"
                  >
                    解除鎖定
                  </button>
                  <button
                    v-if="!info.is_locked && info.status === 2"
                    class="btn btn-default"
                    @click="menuLock"
                  >
                    鎖定
                  </button>
                  <button
                    v-if="info.is_locked && info.status === 2"
                    class="bg-black btn"
                    @click="goToCrSchedule(info)"
                  >
                    上架
                  </button>
                  <button
                    v-if="info.is_locked && info.status === 2"
                    class="btn btn-default"
                    @click="exportFile"
                  >
                    <i class="fa fa-download" />
                    匯出菜單
                    <clip-loader
                      class="cliploading"
                      :loading="show.download"
                      color="#528BB8"
                      size="16px"
                    />
                  </button>
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  菜單狀態
                </span>
                <div class="form-control form-info">
                  {{ info.status }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  版本時間
                </span>
                <div class="form-control form-info">
                  {{ info.ver_time }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  更新時間
                </span>
                <div class="form-control form-info">
                  {{ info.update_time }}
                </div>
              </div>
              <br>
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  建立時間
                </span>
                <div class="form-control form-info">
                  {{ info.create_time }}
                </div>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">
              菜單
            </h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div
              v-if="show.noMenu"
              class="text-center text-red"
            >
              尚未建立菜單喔！
            </div>
            <div
              id="example1_wrapper"
              class="dataTables_wrapper dt-bootstrap form-inline"
            >
              <div class="grid row">
                <!-- menu -->
                <MenuLogic
                  type="list"
                  :menu="menu"
                  :schema="schema"
                  :layout="layout"
                  :show-product-icon="showProductIcon"
                  :change-to-product-list="changeToProductList"
                  :check-disable-item="checkDisableItem"
                  :open-modal="openModal"
                  :get-icon="getIcon"
                  :is-search="isSearch"
                  :show-menu-icon="showMenuIcon"
                  :loading="loading"
                  :min-price="minPrice"
                />
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
      <!-- Modal -->
      <MenuModal
        :current-product="currentProduct"
        :menu-json="currentMenuJson"
      />

      <PackageModal
        :current-product="currentProduct"
        :menu-json="currentMenuJson"
      />
    </div>
  </section>
</template>

<script>
// core
import $ from 'jquery'
import { mapGetters } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import Masonry from 'masonry-layout'
import moment from 'moment'
// components
import menuModal from './Temp/MenuModalNew.vue'
import packageModal from './Temp/MenuPackageModalNew.vue'
import MenuLogic from './Temp/MenuLogic.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'MenuInfo',
  components: {
    ClipLoader: ClipLoader,
    MenuModal: menuModal,
    MenuLogic: MenuLogic,
    PackageModal: packageModal
  },
  extends: NdExtendHandleMenu,
  data () {
    return {
      current: {
        productId: 0,
        product: []
      },
      tableIndex: 1,
      info: {},
      menu: {
        categoryList: [],
        productList: [],
        adjustList: [],
        optionList: [],
        combineList: [],
        productNewList: [],
        blockList: [],
        packageList: []
      },
      currentMenuJson: '',
      show: {
        download: false,
        noMenu: false
      },
      schema: {
        category: {},
        product: {},
        block: {},
        adjust: {},
        option: {},
        combine: {}
      },
      layout: 1,
      showProductIcon: false,
      disableItems: [],
      disable: {
        product: {},
        category: [],
        option: {},
        adjust: [],
        block: {},
        item: {},
        pBlock: {}
      },
      isSearch: false,
      showMenuIcon: 0,
      loading: {
        menu: true
      },
      minPrice: {},
      currentProduct: []
    }
  },
  mounted () {
    this.$nextTick().then(() => {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
    })
    if (this.getRoleType === 99) {
      this.getExtendHandleMenuInfo()
    }
  },
  updated () {
    this.$nextTick().then(() => {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
    })
  },
  methods: {
    changeToProductList (number) {
      return this.menu.productList[number]
    },
    checkDisableItem (productId, categoryId) {
      return true
    },
    openModal (productListNumber, noDis) {
      const newProduct = this.changeToProductList(productListNumber)
      this.$set(this, 'currentProduct', newProduct)
    },
    getIcon (pId) {
      return []
    },
    openProductModal (product, index) {
      this.current.productId = index
      this.current.product = product
    },
    setSelectAndMenu () {
      this.$set(this, 'currentMenuJson', JSON.parse(this.currentMenuJson))
      this.menu.categoryList = this.currentMenuJson.category_list_json.data
      // sort
      var menu = []
      for (var key in this.menu.categoryList) {
        menu.push(this.menu.categoryList[key])
      }
      menu.sort(function (a, b) {
        return a[1] - b[1]
      })
      this.menu.categoryList = menu
      this.menu.productList = this.currentMenuJson.product_list_json.data
      this.menu.adjustList = this.currentMenuJson.adjust_list_json.data
      this.menu.optionList = this.currentMenuJson.option_list_json.data
      this.menu.combineList = this.currentMenuJson.combine_list_json.data
      this.schema.category = this.currentMenuJson.category_list_json.schema
      this.schema.product = this.currentMenuJson.product_list_json.schema
      if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema
      this.schema.adjust = this.currentMenuJson.adjust_list_json.schema
      this.schema.option = this.currentMenuJson.option_list_json.schema
      this.schema.combine = this.currentMenuJson.combine_list_json.schema
    },
    getCommonPrice (combineNumList) {
      // change to combine
      var combineList = [] // isCommon
      var commonPriceList = []
      for (var i = 0; i < combineNumList.length; i++) {
        if (this.menu.combineList[combineNumList[i]][4]) combineList.push(this.menu.combineList[combineNumList[i]])
      }
      for (var j = 0; j < combineList.length; j++) {
        if (combineList[j][2]) {
          commonPriceList.push({
            cold: {
              name: combineList[j][1], price: combineList[j][2]
            },
            hot: {
              name: combineList[j][1], price: combineList[j][2]
            }
          })
        } else {
          var common = this.getSumPrice(combineList[j][5])
          commonPriceList.push(common)
        }
      }
      var minCommonPrice = []
      minCommonPrice.push(this.checkLowerPrice(commonPriceList))
      return minCommonPrice
    },
    getSumPrice (edgeNumList) {
      var priceList = []
      var aList = this.menu.adjustList
      var oList = this.menu.optionList
      var pList = this.menu.productList
      var priceObj = {
        cold: {
          name: '',
          price: 0
        },

        hot: {
          name: '',
          price: 0
        },

        temp: false
      }
      for (var key in edgeNumList) {
        var id = edgeNumList[key][0]
        var edgePrice = edgeNumList[key][2]
        // console.log(edgeNumList[key])
        if (typeof aList[id] !== 'undefined' && aList[id][11]) {
          var aPrice = aList[id][4]
          if (edgePrice) aPrice = edgePrice
          if (aList[id][4]) priceList.push({id: aList[id][0], name: aList[id][2], price: aPrice, sub_type: aList[id][7]})
          else {
            for (var j = 0; j < aList[id][14].length; j++) {
              var oListNum
              oListNum = aList[id][14][j]
              if (typeof oListNum === 'object') oListNum = aList[id][14][j][0]
              var aoPrice = oList[oListNum][4]
              if (edgePrice) aoPrice = edgePrice
              if (typeof oList[oListNum] !== 'undefined' && oList[oListNum][4] && oList[oListNum][11]) {
                priceList.push({id: oList[oListNum][0], name: oList[oListNum][2], price: aoPrice, sub_type: oList[oListNum][7]})
              }
            }
          }
        } else if (typeof oList[id] !== 'undefined' && oList[id][4] && oList[id][11]) {
          var oPrice = oList[id][4]
          if (edgePrice) oPrice = edgePrice
          priceList.push({id: oList[id][0], name: oList[id][2], price: oPrice, sub_type: oList[id][7]})
        } else if (typeof pList[id] !== 'undefined' && pList[id][4] && pList[id][11]) {
          var pPrice = pList[id][4]
          if (edgePrice) pPrice = edgePrice
          priceList.push({id: pList[id][0], name: pList[id][2], price: pPrice, sub_type: pList[id][7]})
        }
        if (typeof aList[id] !== 'undefined') {
          if (aList[id][7] === 40) priceObj.temp = true
        } else if (typeof oList[id] !== 'undefined') {
          var isTemp = oList[id][7]
          if (isTemp === 41 || isTemp === 42 || isTemp === 43 || isTemp === 44 ||
            isTemp === 45 || isTemp === 46 || isTemp === 47 || isTemp === 48 || isTemp === 49) {
            priceObj.temp = true
          }
        }
      }
      for (var i = 0; i < priceList.length; i++) {
        // console.log(priceList[i])
        var temp = priceList[i].sub_type
        if (temp === 41 || temp === 42 || temp === 43) {
          priceObj.cold.name = priceObj.cold.name + priceList[i].name
          priceObj.cold.price = priceObj.cold.price + priceList[i].price
        } else if (temp === 44 || temp === 45 || temp === 46 || temp === 47 || temp === 48 || temp === 49) {
          priceObj.hot.name = priceObj.hot.name + priceList[i].name
          priceObj.hot.price = priceObj.hot.price + priceList[i].price
        } else {
          priceObj.cold.name = priceObj.cold.name + priceList[i].name
          priceObj.cold.price = priceObj.cold.price + priceList[i].price
          priceObj.hot.name = priceObj.hot.name + priceList[i].name
          priceObj.hot.price = priceObj.hot.price + priceList[i].price
        }
      }
      return priceObj
    },
    exportFile () {
      this.show.download = true
      let name = this.info.name
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/exportProductBrief'
      this.getFile('get', url, null, (response) => {
        this.show.download = false
        let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = objectUrl
        a.download = `${name}_${moment().format('YYYYMMDD')}.csv`
        document.body.appendChild(a)
        a.click()
      })
    },
    checkLowerPrice (commonPriceList) {
      var coldPrice = []
      var hotPrice = []
      var minPriceObj = {
        cold: {
          price: 0
        },
        hot: {
          price: 0
        },
        temp: false
      }
      for (var i = 0; i < commonPriceList.length; i++) {
        coldPrice.push(commonPriceList[i].cold.price)
        hotPrice.push(commonPriceList[i].hot.price)
        minPriceObj.temp = commonPriceList[i].temp
      }
      minPriceObj.cold.price = Math.min.apply(Math, coldPrice)
      minPriceObj.hot.price = Math.min.apply(Math, hotPrice)
      return minPriceObj
    },
    getMenuInfo (lockState) {
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.info = response.data.menu
          if (!lockState) {
            if (response.data.json_menu) {
              this.currentMenuJson = response.data.json_menu
              window.sessionStorage.setItem('Nidin_ecms_menu', response.data.json_menu)
              this.setSelectAndMenu()
            } else {
              this.show.noMenu = true
            }
          }
        }
      })
    },
    goToCrSchedule (info = {}) {
      console.log('goToCrSchedule')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }
      let query = {
        menu_id: info.menu_id,
        menu_name: info.name
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuScheduleCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crSchedule'
      }

      this.$router.push({ name, params, query })
    },
    menuUnlock () {
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/unlock'
      this.getDataH('put', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功解除菜單鎖定',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuInfo('unlock')
        }
      })
    },

    menuLock () {
      const url = this.base + this.id + '/menu/' + this.$route.params.menu_id + '/lock'
      this.getDataH('put', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功鎖定菜單',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuInfo('lock')
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    sortCategoryList () {
      var category = this.menu.categoryList
      var products = []
      category.sort(function (a, b) {
        return a[1] - b[1]
      })
      for (var i = 0; i < category.length; i++) {
        var product = []
        for (var j = 0; j < category[i][6].length; j++) {
          product.push(this.menu.productList[category[i][6][j]])
        }
        // sort product
        product.sort(function (a, b) {
          return a[1] - b[1]
        })
        products[category[i][0]] = product
      }
      // console.log(products)
      this.menu.productNewList = products
      return category
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getFile () {
      return this.$parent.getFile
    }
  },
  created () {
    this.getMenuInfo()
  }
}
</script>



// WEBPACK FOOTER //
// MenuInfo.vue?8884bba6